import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from '@mui/material'
import * as React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { useAppSelector } from 'reduxStore/hooks'

export default function CancellationDetails() {
  const accountDetailsByid = useAppSelector((state) => state.accountDetails)
  return (
    <Card  sx={{ minHeight: '200px' }}>
      <CardHeader
        avatar={<CloseIcon sx={{ fontWeight: 'bold' }} />}
        title={
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Cancellation Details
          </Typography>
        }
      ></CardHeader>
      <CardContent sx={{ maxHeight:'130px', overflow:'auto'}} >
        {accountDetailsByid.loading ? (
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <CircularProgress color="inherit" size={30} />
            </Grid>
          </Grid>
        ) : 'accountDetails' in accountDetailsByid ? (
          accountDetailsByid.accountDetails !== undefined ? (
            accountDetailsByid.accountDetails !== null ? (
              'vendor' in accountDetailsByid.accountDetails ? (
                accountDetailsByid.accountDetails.vendor !== undefined ? (
                  accountDetailsByid.accountDetails.vendor !== null ? (
                    'cancellation_details' in accountDetailsByid.accountDetails.vendor ? (
                      accountDetailsByid.accountDetails.vendor.cancellation_details !==
                      undefined ? (
                        accountDetailsByid.accountDetails.vendor.cancellation_details !== null ? (
                          <Box
                            my={1}
                            dangerouslySetInnerHTML={{
                              __html: accountDetailsByid.accountDetails.vendor.cancellation_details,
                            }}
                          />
                        ) : (
                          <Typography variant="subtitle1">No content available</Typography>
                        )
                      ) : (
                        <Typography variant="subtitle1">No content available</Typography>
                      )
                    ) : (
                      <Typography variant="subtitle1">No content available</Typography>
                    )
                  ) : (
                    <Typography variant="subtitle1">No content available</Typography>
                  )
                ) : (
                  <Typography variant="subtitle1">No content available</Typography>
                )
              ) : (
                <Typography variant="subtitle1">No content available</Typography>
              )
            ) : (
              <Typography variant="subtitle1">No content available</Typography>
            )
          ) : (
            <Typography variant="subtitle1">No content available</Typography>
          )
        ) : (
          <Typography variant="subtitle1">No content available</Typography>
        )}
      </CardContent>
    </Card>
  )
}
